import axios from 'axios';
import { updateArticlePhotoImage, fetchArticlePhotoSource } from '../articleFolder/articlePhotoApi';
import { updateMachineContentPhotoImage, fetchMachineContentPhotoSource } from '../content/machineContentPhotoApi';

function scopeBase(scope) {
  return scope === 'machine' ? 'machine-content-gallery' : 'article-gallery';
}

function appendCrop(formData, prepared) {
  formData.append('croppedAreaPixels', JSON.stringify(prepared?.croppedArea ?? {}));
  formData.append('aspectRatio', String(prepared?.aspectRatio ?? 1));
  formData.append('cropShape', prepared?.cropShape ?? 'rect');
  formData.append('rotation', String(prepared?.rotation ?? 0));
  if (prepared?.originalFile) {
    formData.append('originalFile', prepared.originalFile);
  }
  formData.append('croppedFile', prepared.croppedFile);
  return formData;
}

export function createGalleryDocument(scope, parentId, file, label) {
  const formData = new FormData();
  formData.append('file', file);
  if (label) {
    formData.append('label', label);
  }
  return axios.post(`${scopeBase(scope)}/${parentId}/document`, formData);
}

export function createGalleryVideoFile(scope, parentId, file, label) {
  const formData = new FormData();
  formData.append('file', file);
  if (label) {
    formData.append('label', label);
  }
  return axios.post(`${scopeBase(scope)}/${parentId}/video`, formData);
}

export function createGalleryVideoLink(scope, parentId, url, label) {
  const formData = new FormData();
  formData.append('url', url);
  if (label) {
    formData.append('label', label);
  }
  return axios.post(`${scopeBase(scope)}/${parentId}/video`, formData);
}

export function createGalleryPhoto(scope, parentId, prepared, label) {
  const formData = appendCrop(new FormData(), prepared);
  if (label) {
    formData.append('label', label);
  }
  return axios.post(`${scopeBase(scope)}/${parentId}/photo`, formData);
}

export function updateGalleryLabel(scope, itemId, label) {
  return axios.patch(`${scopeBase(scope)}/item/${itemId}`, { label });
}

export function reorderGallery(scope, parentId, ids) {
  return axios.patch(`${scopeBase(scope)}/${parentId}/order`, { ids });
}

export function deleteGalleryItem(scope, itemId) {
  return axios.delete(`${scopeBase(scope)}/item/${itemId}`);
}

export function updateGalleryPhoto(scope, photoId, prepared) {
  return scope === 'machine'
    ? updateMachineContentPhotoImage(photoId, prepared)
    : updateArticlePhotoImage(photoId, prepared);
}

export function fetchGalleryPhotoSource(scope, photo) {
  return scope === 'machine'
    ? fetchMachineContentPhotoSource(photo)
    : fetchArticlePhotoSource(photo);
}

export async function persistLocalGalleryItems(scope, parentId, localItems) {
  for (const item of localItems || []) {
    if (item.kind === 'photo') {
      await createGalleryPhoto(scope, parentId, item.prepared, item.label);
    } else if (item.kind === 'document') {
      await createGalleryDocument(scope, parentId, item.file, item.label);
    } else if (item.kind === 'video' && item.file) {
      await createGalleryVideoFile(scope, parentId, item.file, item.label);
    } else if (item.kind === 'video' && item.externalUrl) {
      await createGalleryVideoLink(scope, parentId, item.externalUrl, item.label);
    }
  }
}
